import { render } from "./Proposal.vue?vue&type=template&id=6bef50ff&scoped=true&ts=true"
import script from "./Proposal.vue?vue&type=script&setup=true&lang=ts"
export * from "./Proposal.vue?vue&type=script&setup=true&lang=ts"

import "./Proposal.vue?vue&type=style&index=0&id=6bef50ff&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bef50ff"],['__file',"src/views/me/Proposal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6bef50ff"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6bef50ff', __exports__)) {
    console.log('reload')
    api.reload('6bef50ff', __exports__)
  }
  
  module.hot.accept("./Proposal.vue?vue&type=template&id=6bef50ff&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('6bef50ff', render)
  })

}


export default __exports__